import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import { db } from './config';
import { analyticsService } from './analyticsService';

// Service pour gérer les contacts
export const contactService = {
  // Ajouter un nouveau contact
  async addContact(contactData) {
    try {
      const docRef = await addDoc(collection(db, 'contacts'), {
        ...contactData,
        timestamp: serverTimestamp(),
        status: 'new'
      });
      
      // Tracer l'événement analytics
      analyticsService.trackFormSubmission(contactData.source, contactData);
      
      return {
        success: true,
        id: docRef.id,
        message: 'Contact enregistré avec succès'
      };
    } catch (error) {
      console.error('Erreur lors de l\'ajout du contact:', error);
      throw new Error('Erreur lors de l\'enregistrement du contact');
    }
  },

  // Envoyer un email de confirmation au client (EmailJS REST API)
  async sendConfirmationEmail(contactData) {
    try {
      const serviceId = process.env.REACT_APP_EMAILJS_SERVICE_ID;
      const templateId = process.env.REACT_APP_EMAILJS_TEMPLATE_ID;
      const publicKey = process.env.REACT_APP_EMAILJS_PUBLIC_KEY;

      if (!serviceId || !templateId || !publicKey) {
        // Config manquante: on ignore silencieusement en prod
        return { success: false, message: 'EmailJS non configuré' };
      }

      const payload = {
        service_id: serviceId,
        template_id: templateId,
        user_id: publicKey,
        template_params: {
          to_email: contactData.email,
          to_name: contactData.firstName || 'Client',
          project_service: contactData.service || 'Projet de rénovation',
          message: contactData.message || '',
          phone: contactData.phone || '',
          source: contactData.source || '',
        }
      };

      const res = await fetch('https://api.emailjs.com/api/v1.0/email/send', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });

      if (!res.ok) {
        return { success: false, message: 'Echec envoi EmailJS' };
      }

      return { success: true };
    } catch (error) {
      // Ne pas casser le flux si l'email échoue
      return { success: false, message: 'Erreur envoi email' };
    }
  },

  // Logger une tentative OTP
  async logOtpAttempt(phone, status, details = {}) {
    try {
      await addDoc(collection(db, 'otp_logs'), {
        phone,
        status, // 'sent', 'verified', 'failed', 'error'
        timestamp: serverTimestamp(),
        userAgent: navigator.userAgent || 'unknown',
        ...details
      });
    } catch (error) {
      console.error('Erreur log OTP:', error);
    }
  },

  // Valider les données du contact
  validateContact(contactData) {
    const { firstName, lastName, phone, email } = contactData;
    const errors = [];

    if (!firstName || firstName.trim() === '') {
      errors.push('Le prénom est requis');
    }

    // Le nom de famille n'est requis que s'il est fourni (pour les formulaires complets)
    // Pour le formulaire Hero simplifié, lastName peut être vide
    if (lastName !== undefined && lastName !== null && lastName.trim() === '') {
      errors.push('Le nom est requis');
    }

    if (!phone || phone.trim() === '') {
      errors.push('Le téléphone est requis');
    }

    if (email && email.trim() !== '' && !/\S+@\S+\.\S+/.test(email)) {
      errors.push('Format d\'email invalide');
    }

    return {
      isValid: errors.length === 0,
      errors
    };
  }
};
